<fgb-page-header
  [pageTitle]="'wallet.page.title'"
  [showBalance]="false"
  [showFooter]="false"
  [backButtonLink]="'/'"
/>

<div class="container d-lg-none bg-black" #barcodeRef>
  <fgb-barcode [showSeating]="true" [centerMemberInfo]="true"></fgb-barcode>
</div>

<!-- Wallet -->
<div #walletContainer class="wallet-container">
  <div class="grab-point d-lg-none">
    <span class="minimize-icon"> </span>
  </div>

  <!-- CM Offers -->
  <fgb-campaigns-v2-offers-list
    [showAllOffers]="false"
  ></fgb-campaigns-v2-offers-list>

  <!-- My Rewards -->
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="container pt-lg-4">
      <fgbcl-rewards-wallet-redeem-list
        [unRedeemedItems]="walletItems"
      ></fgbcl-rewards-wallet-redeem-list>
    </div>
  </ng-container>

  <!-- Claimed Rewards -->
  <div class="container mb-lg-5" style="margin-top: 30px">
    <div class="claimed-card">
      <div class="claimed-card-body">
        <h2 class="claimed-card-title">
          {{ "wallet.redeemed.title" | translate }}
        </h2>
        <p class="claimed-card-subtitle">
          {{ "wallet.page.claimed.rewards.subtitle" | translate }}
        </p>
      </div>
      <a class="claimed-card-btn fw-bold" [routerLink]="['/rewards/claimed']">
        {{ "rewards.wallet.view.claimed" | translate }}
      </a>
    </div>
  </div>
</div>
